
var $ = jQuery.noConflict();

$(function(){

    
    $('.fdp-current-country').on('click', function() {
        const $parent = $(this).parent(); // Store the parent element in a variable
        $parent.toggleClass('active');
    
        setTimeout(() => {
            $parent.toggleClass('animation-active'); // Use the stored parent element
        }, 50);
    });


      // Collection Image Visibility Setup
      function setupCollectionImageVisibility() {
        // For scroll-based visibility
        const menuItems = document.querySelectorAll('.menu-lv-3-collection-image');
        
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                }
            });
        }, {
            threshold: 0.1
        });

        menuItems.forEach(item => {
            observer.observe(item);
        });

        // Set sidebar height and handle first item visibility
        $('.menu-lv-1.has-megamenu.costumes-menu-item .menu-dropdown .menu-dropdown__column').each(function() {
            // Add is-visible to first .site-nav-sub-collection-image1
            $(this).find('.site-nav-sub-collection-image1').first().addClass('is-visible');

            // Set sidebar height for each .site-nav-sub
           /* $(this).find('.site-nav-sub').each(function() {
                const sidebarHeight = $(this).outerHeight();
                $(this).attr('style', '--sidebar-height: ' + sidebarHeight + 'px');
            });*/
        });

        // For hover and click-based visibility
        $('.menu-lv-1.has-megamenu.costumes-menu-item .menu-dropdown .site-nav.dropdown > .site-nav-list > a').each(function() {
            const $link = $(this);
            const $parentItem = $link.closest('.site-nav-sub-collection-image1');
            const $allItems = $parentItem.parent().find('.site-nav-sub-collection-image1');
            
            // Handle hover
            $link.on('mouseenter', function() {
                $allItems.removeClass('is-visible');
                $parentItem.addClass('is-visible');
            });

            // Handle click for mobile
            $link.on('click', function(e) {
                if (!$parentItem.hasClass('is-visible')) {
                    e.preventDefault();
                    $allItems.removeClass('is-visible');
                    $parentItem.addClass('is-visible');
                }
            });
        });

        // Reset visibility when menu closes
        $('.menu-lv-1.has-megamenu.costumes-menu-item').on('mouseleave', function() {
            const $column = $(this).find('.menu-dropdown__column');
            const $items = $column.find('.site-nav-sub-collection-image1');
            $items.removeClass('is-visible');
            $items.first().addClass('is-visible');
        });

        // Update sidebar height on window resize
        /*$(window).on('resize', function() {
            $('.menu-lv-1__action[href*="/collections/costumes"] ~ .menu-dropdown .site-nav.dropdown.is-visible > .site-nav-list > a + div.site-nav-sub').each(function() {
                const sidebarHeight = $(this).outerHeight();
                $(this).attr('style', '--sidebar-height: ' + sidebarHeight + 'px');
            });*/
    }

    // Initialize collection image visibility
    setupCollectionImageVisibility();

    $fdpMainSldier = $('.custom-slideshow-wrapper .custom-slideshow');

    $fdpMainSldier.on('init', function(event, slick, direction){

        $('.slick-active').addClass('first-slide');        

        setTimeout(function() {
            
            $('.slick-active').addClass('animation-active');           

        }, 125); 

     //console.log('init1')
        

    })

    $fdpMainSldier.each(function () {
        var self = $(this),
            dataArrows = self.data('arrows'),
            dataDots = self.data('dots'),
            autoplay = self.data('autoplay'),
            autoplaySpeed = self.data('autoplay-speed')
  


            self.slick({
        dots: true,
        //infinite: true,
        autoplay: self.data('autoplay'),
        autoplaySpeed: self.data('autoplay-speed'),
        //arrows: self.data('arrows'),
        speed: 500,
        slidesToShow: 1,
        pauseOnHover: true,
        nextArrow: window.arrows.icon_next,
        prevArrow: window.arrows.icon_prev,
        responsive: [
            {
              breakpoint: 820,
              settings: {
                arrows: false,
                dots: true
              }
            }
          ]
        });



      $fdpMainSldier.on('swipe', function(event, slick, direction){
        //console.log(direction);
        // left
        });

        // On edge hit
        $fdpMainSldier.on('edge', function(event, slick, direction){
        //console.log('edge was hit')
        });

        // On before slide change
        $fdpMainSldier.on('beforeChange', function(event, slick, currentSlide, nextSlide){

          //  console.log('beforeChange/init', event, slick, slick.$slides);

           // console.log(nextSlide);
           // console.log( $(this) );
           
          
            
        });

        $fdpMainSldier.on('afterChange init', function(event, slick, direction){
            //console.log('afterChange/init', event, slick, slick.$slides);
            // remove all prev/next
            //slick.$slides.removeClass('prevdiv').removeClass('nextdiv');

            // find current slide
            for (var i = 0; i < slick.$slides.length; i++)
            {
                var $slide = $(slick.$slides[i]);
                if ($slide.hasClass('slick-current')) {
                    // update DOM siblings
                    //$slide.prev().addClass('prevdiv');
                    $slide.prev().addClass('load-images');
                    $slide.next().addClass('load-images');

                    $slide.addClass('load-images');
                    $('.slick-slide').removeClass('first-slide');
                    break;
                }
            }


            setTimeout(function() {
            
                $('.slick-active').addClass('animation-active');           

            }, 125); 

             
        }); // $fdpMainSldier

        

    $fdpMainSldier.on('beforeChange', function(event, slick) {
        $('.slick-slide').removeClass('animation-active');  
    })


});

    //$('.rbr-mbap_item_info .pl-swatches-collection').remove();

    	
$('.custom-featured-photo').viewportChecker({    
	offset: -750
});

	
    // Add fixed-header class
	if ( ! $('body').hasClass('checkout') ) {
	 
		/* Sticky menu	*/
		var $document3 = $(document),
			$element3 = $('body'),
			className3 = 'fixed-header';

		$document3.scroll(function() {
		  $element3.toggleClass(className3, $document3.scrollTop() >= 240);	  
		});	
			
	}

    
      // Load Category Icons in Menu - on mouseover
	$('.menu-lv-1.has-megamenu.dropdown').on('mouseover', function() {	
		$(this).addClass('menu-icons-active');	
	});



    function sg9ClickableDropdownMenuDesktop() {

        var documentWidth = $(document).width();

   /* 
    
        if (documentWidth > 1024) {
            
          

          // Touch Screen Menu Level 1 Dropdown
            $('.menu-lv-1.has-megamenu.dropdown > span[aria-label="Drop Down Menu"]').on('click', function() {	
                    
                if ( $(this).hasClass('menu-dropdown-active')  ) {
                    $('span[aria-label="Drop Down Menu"]').removeClass('menu-dropdown-active');	
                    $(this).removeClass('menu-dropdown-active');	
                    //$(this).closest('.menu-lv-1').removeClass('menu-dropdown-active');

                } else {
                    
                    $('span[aria-label="Drop Down Menu"]').removeClass('menu-dropdown-active');	

                    $(this).addClass('menu-dropdown-active');	
                    $(this).closest('.menu-lv-1').addClass('menu-icons-active');

                }

            });

              // Touch Screen Menu Level 1 Dropdown
              $('.menu-lv-1.has-megamenu.dropdown').on('mouseover', function() {	
                    
                $('span[aria-label="Drop Down Menu"]').removeClass('menu-dropdown-active');	
                //$('.menu-lv-1').removeClass('menu-dropdown-active');                

            });

        } else {

            $('span[aria-label="Drop Down Menu"]').removeClass('menu-dropdown-active');	
           //$('.menu-lv-1').removeClass('menu-dropdown-active');

        }
*/
 
    
    }; // sg9ClickableDropdownMenuDesktop()

    sg9ClickableDropdownMenuDesktop(); 


 
 



    $('.halo-product-block[data-simple-product-card="slider-simple-product-card"] .pl-swatches-collection').remove();
    $('.halo-product-block[data-simple-product-card="slider-simple-product-card"] .card-action').remove();
        




if ( $('body').hasClass('template-product') ) { 

    setTimeout(function() {

        $('.pl-swatches__color').each(function() {
            $(this).closest('a.pl-swatches__link').addClass('swatch-color');
    
        $('.pl-swatches__tooltip').each(function() {
            let text = $(this).text();
    
           /* if (text.includes("Checkerboard")) {
                $(this).text(text.replace(/Checkerboard/g, "Checker-board"));
            }
    
            if (text.includes("Pomegranate")) {
                $(this).text(text.replace(/Pomegranate/g, "Pome-granate"));
            }
    
            if (/Rectangular\b/i.test(text)) {
                $(this).text(text.replace(/\bRectangular\b/gi, "Rectangu-lar"));
            }
    
            if (text.includes("/Gold")) {
                $(this).text(text.replace(/\/Gold/g, "/ Gold"));
            }
    
            if (text.includes("/")) {
                $(this).text(text.replace(/\//g, " / "));
            }*/
        });
        });
    
        $('.pl-swatches__tooltip').each(function() {
            let text = $(this).text();
    
           /* if (text.includes("Checkerboard")) {
                $(this).text(text.replace(/Checkerboard/g, "Checker-board"));
            }
    
            if (text.includes("Pomegranate")) {
                $(this).text(text.replace(/Pomegranate/g, "Pome-granate"));
            }
    
            if (/Rectangular\b/i.test(text)) {
                $(this).text(text.replace(/\bRectangular\b/gi, "Rectangu-lar"));
            }
    
            if (text.includes("/Gold")) {
                $(this).text(text.replace(/\/Gold/g, "/ Gold"));
            }
    
            if (text.includes("/")) {
                $(this).text(text.replace(/\//g, " / "));
            }*/

                
        });
    
    }, 250);
    
   
  
}


$('.faq-items__item-content').hide();

$('.faq-items__item-title').on('click',function(){
    
    if($(this).hasClass('expand')){
        $(this).removeClass('expand');
        $(this).next().slideUp();
        $(this).find('.fa-minus').addClass('fa-plus').removeClass('fa-minus');
        $(this).attr('aria-expanded', false)
    
    } else {
        $(this).addClass('expand');
        $(this).next().slideDown();
        $(this).find('.fa-plus').removeClass('fa-plus').addClass('fa-minus');
        $(this).attr('aria-expanded', true)
    }

});



if ($('body').hasClass('template-collection')) {



    $contentHeight = $('.collection-description').outerHeight(true);

    console.log("$contentHeight" + $contentHeight);

    if ($contentHeight > 319) {

        $('.collection-info-item .collection-description').after('<button class="button button--secondary"><span>Read More</span></button>');

        $('.collection-info-item .collection-description + button.button').on('click', function() {

            $('.collection-info-item .collection-description').css('max-height', '9999px');

            

            $('.collection-info-item .collection-description + button.button').remove();
        
            setTimeout(() => {
                $('.collection-description').addClass('remove-overflow');
                $('.collection-description').css('max-height', 'unset');
                
            }, 500);
        
        });

        
    } else {

        $('.collection-info-item .collection-description').addClass('remove-overflow');

    }

    
    
}



function sg9ProductHugeDeal() {


    if ($('body').hasClass('template-product-huge-deal')) {

        var documentWidth = $(document).width();

        $('.product-description ul').hide();

        $('.product-description p:first-child strong').on('click',function(){

        if($(this).parent().hasClass('expand')){
            $(this).parent().removeClass('expand');
            $(this).parent().next().slideUp();
            $(this).parent().find('.fa-minus').addClass('fa-plus').removeClass('fa-minus');
            $(this).parent().attr('aria-expanded', false)

        } else {
            $(this).parent().addClass('expand');
            $(this).parent().next().slideDown();
            $(this).parent().find('.fa-plus').removeClass('fa-plus').addClass('fa-minus');
            $(this).parent().attr('aria-expanded', true)
        }

    });

    }




} // sg9ProductHugeDeal()

sg9ProductHugeDeal();

function sg9ExpandProductSpecifications() {
        
    if ( $('body').hasClass('template-product') ) { 

        //var documentWidth = $(document).width();        
        var documentWidth = $(window).outerWidth();        
        //var documentWidth = $(window).width();        
        
        // Remove any existing click handlers to prevent stacking
        $('.product-specifications-title').off('click');
        
        // Handle visibility and click functionality based on width
        if (documentWidth > 550) {                
            $('#product-specifications').show();
            $('.product-specifications-title').attr('aria-expanded', true).addClass('expand');
        } else {
            $('#product-specifications').hide();
            $('.product-specifications-title').attr('aria-expanded', false).removeClass('expand');
            
            // Only set up click handler for mobile view
            $('.product-specifications-title').on('click',function(){
                if($(this).hasClass('expand')){
                    $(this).removeClass('expand');
                    $(this).next().slideUp();
                    $(this).find('.fa-minus').addClass('fa-plus').removeClass('fa-minus');
                    $(this).attr('aria-expanded', false);
                } else {
                    $(this).addClass('expand');
                    $(this).next().slideDown();
                    $(this).find('.fa-plus').removeClass('fa-plus').addClass('fa-minus');
                    $(this).attr('aria-expanded', true);
                }
            });
        }
    }

//console.log("documentWidth:" + documentWidth);

} // sg9ExpandProductSpecifications()

sg9ExpandProductSpecifications();

    // Run Scripts after Window Resize
	/*! run scirpt after resize by Dolan Antenucci https://stackoverflow.com/users/318870/dolan-antenucci-   - https://stackoverflow.com/posts/5926068/revisions https://stackoverflow.com/questions/5489946/jquery-how-to-wait-for-the-end-of-resize-event-and-only-then-perform-an-ac/5926068#5926068 */
	var rtime;
	var timeout = false;
	var delta = 100;
	$(window).resize(function() {
		rtime = new Date();
		if (timeout === false) {
			timeout = true;
			setTimeout(resizeend, delta);
		}
	});

	function resizeend() {
	   
	   if (new Date() - rtime < delta) {
			setTimeout(resizeend, delta);
		} else {
			timeout = false;
            
            sg9ClickableDropdownMenuDesktop();

            sg9ExpandProductSpecifications();
            //sgAddMenuItem();
				   
		}           
		
	} // resizeend()



}) // document ready
